import React from "react";
import { useParams } from "react-router-dom";
import Marquee from "../components/Marquee";
import ProductCard from "../components/ProductCard";
import { categories } from "../mock/mock";

const CategoryPage = ({ categoryKey }) => {
  const params = useParams();
  const key = categoryKey || params.key;
  const cat = categories[key];

  if (!cat) {
    return (
      <div className="max-w-3xl mx-auto px-5 py-32 text-center">
        <h1 className="font-title text-3xl text-[#4A3B3F]">Catégorie introuvable</h1>
      </div>
    );
  }

  return (
    <div>
      {/* Hero */}
      <section className="relative h-[46vh] min-h-[340px] w-full overflow-hidden">
        <img src={cat.hero} alt={cat.title} className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 to-black/55" />
        <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-5">
          <span className="fade-up font-body text-xs tracking-[0.35em] uppercase text-white/90">Rim Patisse</span>
          <h1 className="fade-up font-title text-4xl md:text-6xl text-white mt-4" style={{ animationDelay: "100ms" }}>{cat.title}</h1>
          <p className="fade-up font-body text-white/85 mt-3 max-w-xl" style={{ animationDelay: "200ms" }}>{cat.subtitle}</p>
        </div>
      </section>

      <Marquee />

      {/* Intro */}
      <section className="max-w-3xl mx-auto px-5 lg:px-8 pt-16 pb-4 text-center">
        <div className="w-16 h-[3px] bg-[#E4A7BC] rounded-full mx-auto mb-6" />
        <p className="font-body text-lg text-[#4A3B3F]/70 leading-relaxed">{cat.intro}</p>
      </section>

      {/* Products */}
      <section className="max-w-7xl mx-auto px-5 lg:px-8 py-14 lg:py-20">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {cat.products.map((p, i) => (
            <ProductCard key={p.id} product={p} index={i} />
          ))}
        </div>
      </section>
    </div>
  );
};

export default CategoryPage;
